/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ID } from '@gh/common-shared-data';
import { AbstractRestService, file, RestSettings } from '@gh/core-data';
import { Observable } from 'rxjs';
import { GraphicalTakeOffPictureDto } from './dto';
import { GraphicalTakeOffPictureMapper } from './picture.mapper';

/**
 * GTO picture REST service
 */
@Injectable()
export class GraphicalTakeOffPictureRestService extends AbstractRestService {
  /**
   * Constructor
   *
   * @param {RestSettings} settings - REST settings
   * @returns {void}
   */
  constructor(settings: RestSettings) {
    super(settings);
  }

  /**
   * Get signed picture URL
   *
   * @param {string} key - Image key
   * @returns {Observable<GraphicalTakeOffPictureDto>} - Picture
   */
  get(key: string): Observable<GraphicalTakeOffPictureDto> {
    return this.httpGet(`${this.bp}/pictures/signed-url?key=${key}`, GraphicalTakeOffPictureMapper);
  }

  /**
   * Create image from PDF file
   *
   * @param {string} key - File key
   * @param {number} page - Page number
   * @returns {Observable<GraphicalTakeOffPictureDto>} - Picture
   */
  create(key: string, page: number): Observable<GraphicalTakeOffPictureDto> {
    key = encodeURIComponent(key);
    return this.httpPost(`${this.bp}/pictures/pdfs/${key}/pages/${page}`, {}, GraphicalTakeOffPictureMapper);
  }

  downloadFromGDrive(id: ID): Observable<Blob> {
    return this.httpGet(`${this.bp}/pictures/download-from-google`, { id }, void 0, file());
  }
}
